import React from 'react';
import { Helmet } from 'react-helmet-async';

import './styles.scss';

const Nosotros = () => {
  return (
    <section className='nosotros my-5'>
      <Helmet>
        <title>Nosotros - Click Hogar | Mueblería en Bahía Blanca</title>
        <meta name="description" content="Conocé Click Hogar: muebles que inspiran, hogares que brillan. Envíos gratis en Bahía Blanca. Visitanos en Brasil 978, Bahía Blanca." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://clickhogarbahia.com.ar/nosotros" />
      </Helmet>
      <div className='container'>
        <div className='row'>
          <div className='col-12 col-md-8 offset-md-2'>
            <h1>¡Click Hogar!</h1>
          </div>
          <div className='col-12 col-md-8 offset-md-2'>
            <p className='mt-4'>En <strong>CLICK HOGAR</strong>, sabemos que tu hogar es tu refugio, y por eso nos dedicamos a ofrecerte muebles que inspiran y espacios que brillan. Nuestra colección está diseñada para transformar cada rincón de tu casa en un lugar único y lleno de estilo. Desde elegantes muebles para tu sala hasta soluciones funcionales para cada habitación, en <strong>CLICK HOGAR</strong> encontrarás todo lo que necesitas para hacer de tu hogar un lugar especial.</p>
            <p>En nuestro compromiso por ofrecerte la mejor experiencia, te brindamos <strong>envíos GRATIS</strong> dentro de Bahía Blanca. Así, puedes disfrutar de la comodidad de recibir tus muebles directamente en tu hogar, sin preocuparte por costos adicionales. Queremos que el proceso de embellecer tu casa sea tan sencillo y agradable como sea posible.</p>
          </div>
        </div>
      </div>

      <div className='separador'>
        <div className='container'>
          <div className='row'>
            <div className='col-12 text-center'>
              <h2>𝐌𝐔𝐄𝐁𝐋𝐄𝐒 𝐐𝐔𝐄 𝐈𝐍𝐒𝐏𝐈𝐑𝐀𝐍, 𝐇𝐎𝐆𝐀𝐑𝐄𝐒 𝐐𝐔𝐄 𝐁𝐑𝐈𝐋𝐋𝐀𝐍</h2>
            </div>
          </div>
        </div>
      </div>

      <div className='container'>
        <div className='row'>
         <div className='col-12 col-md-8 offset-md-2'>
            <p className='mt-4'>Visítanos en nuestra tienda ubicada en <strong>Brasil 978, Bahía Blanca, Buenos Aires 8000</strong>, donde nuestro equipo de expertos estará encantado de ayudarte a encontrar los muebles perfectos para tu estilo y necesidades. Disfruta de una atención personalizada y de una amplia variedad de opciones que se adaptan a todos los gustos y presupuestos.</p>
            <p>En <strong>CLICK HOGAR</strong>, creemos que cada mueble debe contar una historia y cada hogar debe reflejar la personalidad de quienes lo habitan. Ven y descubre cómo nuestros productos pueden inspirarte a crear espacios que no solo cumplen una función, sino que también transmiten belleza y confort. ¡Te esperamos!</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Nosotros;
